import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface TrashIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const TrashIcon: React.FC<TrashIconProps> = ({ ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-plus">
    <path
      d="M18 9
         C18 7.9 18.9 7 20 7
         H30
         C31.1 7 32 7.9 32 9
         V11
         H38
         C39.1 11 40 11.9 40 13
         C40 14.1 39.1 15 38 15
         H12
         C10.9 15 10 14.1 10 13
         C10 11.9 10.9 11 12 11
         H18
         V9
         Z

         M15 18
         C15 16.9 15.9 16 17 16
         H33
         C34.1 16 35 16.9 35 18
         L33.6 36.8
         C33.4 39.3 31.4 41.2 28.9 41.2
         H21.1
         C18.6 41.2 16.6 39.3 16.4 36.8
         L15 18
         Z"
      fill={props.color || 'currentColor'}
    />

  </SvgIcon>
);

export default TrashIcon;
